import formatDate from "../../helpers/dateFormat";

const filterColumnNames = [
  "project_id",
  "property_name",
  "property_number",
  "aliases",
  "site_address",
  "site_city",
  "site_state",
  "site_zip",
  "contact",
  "contact_phone",
  "contact_fax",
  "contact_email",
  "client_name",
  "client_address",
  "client_eq_site",
  "prop_mgr_address",
  "prop_eq_client",
  "ship_address",
  "ship_email",
  "lift_gate_req",
  "ship_eq_client",
  "bill_address",
  "bill_eq_client",
  "po",
  "salesperson",
  "lead_source",
  "lead_date",
  "signed_order",
  "square_feet",
  "due_date",
  "button_1",
  "button_1_content",
  "tenants_entered",
  "button_2",
  "button_2_content",
  "csm_name",
  "button_3",
  "button_3_content",
  "button_4",
  "button_4_content",
  "button_5",
  "button_5_content",
  "button_6",
  "button_6_content",
  "button_7",
  "button_7_content",
  "button_8",
  "button_8_content",
  "button_9",
  "button_9_content",
  "button_10",
  "button_10_content",
  "screen_approval",
  "deposit_invoice",
  "deposit_rcvd",
  "deposit_inv_no",
  "deposit_inv_date",
  "static",
  "multiple_bldg",
  "multiple_bldg_notes",
  "wayfinding",
  "wayfinding_desc",
  "you_are_here",
  "phone",
  "ts_live",
  "extra_button_6",
  "map_quest",
  "traffic_link",
  "image_upload",
  "screen_design",
  "features",
  "features_expanded",
  "other_equip",
  "inst_chklst_rcvd",
  "whiteboard_ready",
  "graphics_completed",
  "project_completed",
  "completed_by",
  "project_tested",
  "tested_by",
  "free_update_period",
  "ts_live_expire",
  "ts_live_fee",
  "online_upd_expire",
  "online_upd_fee",
  "warranty_fee",
  "image_upload_fee",
  "image_upload_desc",
  "folder_name",
  "win_admin_pwd",
  "n_kpwd",
  "ts_admin_pin",
  "login_name",
  "login_pin",
  "ftp_user",
  "ftp_pass",
  "directory_phone",
  "ip_address",
  "installation_notes",
  "tech_notes",
  "last_contact",
  "time_zone",
  "ext_warranty_refused",
  "move_flag",
  "inst_flag",
  "orig_proj_ship_date",
  "rrpmf",
  "production_priority",
  "j_flag",
  "cntrl",
  "last_sale_date",
  "encl_ordered",
  "custom_vinyl",
  "custom_vinyl_desc",
  "w_boverride",
  "on_hold",
  "group_",
  "industry",
  "last_contact_notes",
  "status_notes",
  "last_contact_notes",
  "billing_notes",
  "ko",
  "reseller",
  "subscription_num",
  "all_content_received",
  "premier_content",
  "trial",
  "bundle_package",
  "premier_notes",
  "kick_off_done",
  "bronco",
  "ID",
  "revenue"
];

const enclosureArray: string[] = [];

export const filterProductionReportShippingData = (obj: any) => {
  const productionReportsData = obj.ProductionReports;

  let totalProject: number = 0;
  let totalUnit: number = 0;
  let totalRevenue: number = 0;

  let shippingThisMonthProject: number = 0;
  let shippingThisMonthUnits: number = 0;
  let shippingThisMonthRevenue: number = 0;

  let haveContentProject: number = 0;
  let haveContentUnits: number = 0;
  let haveContentRevenue: number = 0;

  let needContentProject: number = 0;
  let needContentUnit: number = 0;
  let needContentRevenue: number = 0;

  let laterProject: number = 0;
  let laterUnite: number = 0;
  let laterRevenue: number = 0;

  let laterShippingLaterProject: number = 0;
  let laterShippingLaterUnite: number = 0;
  let laterShippingLaterRevenue: number = 0;

  let laterOnHoldProject: number = 0;
  let laterOnHoldUnite: number = 0;
  let laterOnHoldRevenue: number = 0;

  let soldThisMonthProject: number = 0;
  let soldThisMonthUnit: number = 0;
  let soldThisMonthRevenue: number = 0;

  let soldPrevMonthProject: number = 0;
  let soldPrevMonthUnit: number = 0;
  let soldPrevMonthRevenue: number = 0;

  let soldTwoMonthPrevProject: number = 0;
  let soldTwoMonthPrevUnit: number = 0;
  let soldTwoMonthPrevRevenue: number = 0;

  let soldThreeMonthPlusProject: number = 0;
  let soldThreeMonthPlusUnit: number = 0;
  let soldThreeMonthPlusRevenue: number = 0;

  const shippingArray: any = [];
  const haveContentArray: any = [];
  const needContentArray: any = [];
  const onHoldArray: any = [];

  const totalRevenueKey: string = "totalRevenue";

  let i: any = 0;
  for (i; i < productionReportsData.length; i++) {
    const productionReportsFilteredData = formateArray(
      productionReportsData[i]
    );

    if (productionReportsFilteredData) { 
      const shipFullYear: number = new Date(
        productionReportsFilteredData.due_date
      ).getFullYear();
      const shipMonth: number = new Date(
        productionReportsFilteredData.due_date
      ).getMonth();
      const saleFullYear: number = new Date(
        productionReportsFilteredData.last_sale_date
      ).getFullYear();
      const SaleMonth: number = new Date(
        productionReportsFilteredData.last_sale_date
      ).getMonth();

      const currentSaleMonth: string = saleFullYear + "-" + (SaleMonth + 1);
      const prevMonthOfCurrentShipMonth: string =
        shipMonth === 0
          ? shipFullYear - 1 + "-" + 12
          : shipFullYear + "-" + shipMonth;
      const prevTwoMonthOfCurrntShipMonth: string = getPrevTwoMonthOfCurrntShipMonth(
        shipFullYear,
        shipMonth
      );

      if (shipFullYear === saleFullYear && shipMonth === SaleMonth) {
        soldThisMonthProject = soldThisMonthProject + 1;
        soldThisMonthUnit =
          soldThisMonthUnit + productionReportsFilteredData.pcsUnits;
        soldThisMonthRevenue =
          soldThisMonthRevenue + productionReportsFilteredData.totalRevenue;
      } else if (currentSaleMonth === prevMonthOfCurrentShipMonth) {
        soldPrevMonthProject = soldPrevMonthProject + 1;
        soldPrevMonthUnit =
          soldPrevMonthUnit + productionReportsFilteredData.pcsUnits;
        soldPrevMonthRevenue =
          soldPrevMonthRevenue + productionReportsFilteredData.totalRevenue;
      } else if (currentSaleMonth === prevTwoMonthOfCurrntShipMonth) {
        soldTwoMonthPrevProject = soldTwoMonthPrevProject + 1;
        soldTwoMonthPrevUnit =
          soldTwoMonthPrevUnit + productionReportsFilteredData.pcsUnits;
        soldTwoMonthPrevRevenue =
          soldTwoMonthPrevRevenue + productionReportsFilteredData.totalRevenue;
      } else {
        soldThreeMonthPlusProject = soldThreeMonthPlusProject + 1;
        soldThreeMonthPlusUnit =
          soldThreeMonthPlusUnit + productionReportsFilteredData.pcsUnits;
        soldThreeMonthPlusRevenue =
          soldThreeMonthPlusRevenue +
          productionReportsFilteredData.totalRevenue;
      }

      if (getShippingLaterBool(shipFullYear, shipMonth)) {
        laterShippingLaterProject = laterShippingLaterProject + 1;
        laterShippingLaterUnite =
          laterShippingLaterUnite +
          productionReportsFilteredData.pcsUnits;
        laterShippingLaterRevenue =
          laterShippingLaterRevenue +
          productionReportsFilteredData.totalRevenue;
      }

      
      if (
        productionReportsFilteredData.due_date !== "" &&
        productionReportsFilteredData.on_hold === "0" &&
        productionReportsFilteredData.encl_ordered !== "Yes"
      ) {
         if (
        new Date(productionReportsFilteredData.due_date).getMonth() ===
          new Date().getMonth() &&
        new Date(productionReportsFilteredData.due_date).getFullYear() ===
          new Date().getFullYear()
      ) {
        shippingThisMonthProject = shippingThisMonthProject + 1;
        shippingThisMonthUnits =
          shippingThisMonthUnits +
          productionReportsFilteredData.pcsUnits;
        shippingThisMonthRevenue =
          shippingThisMonthRevenue + productionReportsFilteredData.totalRevenue;
      }
      
        productionReportsFilteredData[totalRevenueKey] =
          "$" + productionReportsFilteredData.totalRevenue.toFixed(2);
        shippingArray.push(productionReportsFilteredData);
      }
      if (
        productionReportsFilteredData.due_date === "" &&
        productionReportsFilteredData.all_content_received === "1" &&
        productionReportsFilteredData.on_hold === "0" &&
        productionReportsFilteredData.encl_ordered !== "Yes"
      ) {
        haveContentProject = haveContentProject + 1;
        haveContentUnits =
          haveContentUnits + productionReportsFilteredData.pcsUnits;
        haveContentRevenue =
          haveContentRevenue + productionReportsFilteredData.totalRevenue;
        productionReportsFilteredData[totalRevenueKey] =
          "$" + productionReportsFilteredData.totalRevenue.toFixed(2);
        haveContentArray.push(productionReportsFilteredData);
      }
      if (
        productionReportsFilteredData.due_date === "" &&
        productionReportsFilteredData.all_content_received === "0" &&
        productionReportsFilteredData.on_hold === "0" &&
        productionReportsFilteredData.encl_ordered !== "Yes"
      ) {
        needContentProject = needContentProject + 1;
        needContentUnit =
          needContentUnit + productionReportsFilteredData.pcsUnits;
        needContentRevenue =
          needContentRevenue + productionReportsFilteredData.totalRevenue;
        productionReportsFilteredData[totalRevenueKey] =
          "$" + productionReportsFilteredData.totalRevenue.toFixed(2);
        needContentArray.push(productionReportsFilteredData);
      }
      if (
        productionReportsFilteredData.on_hold === "1" ||
        productionReportsFilteredData.encl_ordered === "Yes"
      ) {
        laterOnHoldProject = laterOnHoldProject + 1;
        laterOnHoldUnite =
          laterOnHoldUnite + productionReportsFilteredData.pcsUnits;
        laterOnHoldRevenue =
          laterOnHoldRevenue + productionReportsFilteredData.totalRevenue;
        productionReportsFilteredData[totalRevenueKey] =
          "$" + productionReportsFilteredData.totalRevenue.toFixed(2);
        onHoldArray.push(productionReportsFilteredData);
      }
    }
  }

  const enclosureCounts = {};
  const enclosureCountsArry = [];
  enclosureArray.forEach(x => {
    enclosureCounts[x] = (enclosureCounts[x] || 0) + 1;
  });

  for (const key in enclosureCounts) {
    if (enclosureCounts.hasOwnProperty(key)) {
      enclosureCountsArry.push({ Enclosure: key, Count: enclosureCounts[key] });
    }
  }

  totalProject =
    soldThisMonthProject +
    soldPrevMonthProject +
    soldTwoMonthPrevProject +
    soldThreeMonthPlusProject;
  totalUnit =
    soldThisMonthUnit +
    soldPrevMonthUnit +
    soldTwoMonthPrevUnit +
    soldThreeMonthPlusUnit;
  totalRevenue =
    soldThisMonthRevenue +
    soldPrevMonthRevenue +
    soldTwoMonthPrevRevenue +
    soldThreeMonthPlusRevenue;

  laterProject = laterOnHoldProject + laterShippingLaterProject;
  laterUnite = laterOnHoldUnite + laterShippingLaterUnite;
  laterRevenue = laterOnHoldRevenue + laterShippingLaterRevenue;

  const Shipping = DropdownFilter(shippingArray, obj.FilterType)
  const HaveContent = DropdownFilter(haveContentArray, obj.FilterType)
  const NeedContent = DropdownFilter(needContentArray, obj.FilterType)
  const OnHold = DropdownFilter(onHoldArray, obj.FilterType)

  return {
    Shipping,
    HaveContent,
    NeedContent,
    OnHold,
    enclosureCountsArry,
    ProjectAggrData: {
      totalProject,
      totalUnit,
      totalRevenue,
      shippingThisMonthProject,
      shippingThisMonthUnits,
      shippingThisMonthRevenue,
      haveContentProject,
      haveContentUnits,
      haveContentRevenue,
      needContentProject,
      needContentUnit,
      needContentRevenue,
      laterOnHoldProject,
      laterOnHoldUnite,
      laterOnHoldRevenue,
      soldThisMonthProject,
      soldThisMonthUnit,
      soldThisMonthRevenue,
      soldPrevMonthProject,
      soldPrevMonthUnit,
      soldPrevMonthRevenue,
      soldTwoMonthPrevProject,
      soldTwoMonthPrevUnit,
      soldTwoMonthPrevRevenue,
      soldThreeMonthPlusProject,
      soldThreeMonthPlusUnit,
      soldThreeMonthPlusRevenue,
      laterProject,
      laterUnite,
      laterRevenue,
      laterShippingLaterProject,
      laterShippingLaterUnite,
      laterShippingLaterRevenue
    }
  };
}

export const getFilterDropDownData = (filterDropdownData: any) => {
  return filterDropdownData.FilterData;
};

export const formateArray = (data: any) => {
  const newArray: any = [];
  const individualCustomerArray = filterPcsArray(data);

  // if (individualCustomerArray.isConsistShipDate === false){

  const sortedArr: any = {};
  const Listings = individualCustomerArray.customerData;
  for (const propertyName in Listings) {
    if (
      filterColumnNames.indexOf(propertyName) !== -1 ||
      propertyName.match(/pos_/i) !== null
    ) {
      // loop through properties
      if (
        propertyName === "last_sale_date" ||
        propertyName === "due_date" ||
        propertyName === "online_upd_expire"
      ) {
        sortedArr[propertyName] =
          Listings[propertyName] === ""
            ? ""
            : formatDate(Listings[propertyName]);
      } else if (propertyName === "property_number") {
        sortedArr[propertyName] = parseInt(Listings[propertyName], 10);
      } else if (
        propertyName === "property_name" ||
        propertyName === "status_notes" ||
        propertyName === "client_name" ||
        propertyName === "last_contact_notes"
      ) {
        if (Listings[propertyName]) {
          sortedArr[propertyName] = Listings[propertyName]
            .trim()
            .replace(/[\/\\]/g, "");
        } else {
          sortedArr[propertyName] = "";
        }
      } else {
        sortedArr[propertyName] = Listings[propertyName];
      }
    }
  }

  const key: any = "pcsUnits";
  sortedArr[key] = individualCustomerArray.totalUnit;
  const key1: any = "totalRevenue";
  sortedArr[key1] = individualCustomerArray.pcsTotalRevenue;

  sortedArr.push = individualCustomerArray.pcsArray;
  newArray.push(sortedArr);
  return sortedArr;

  // } else {
  //   return null
  // }
  
}

export const filterPcsArray = (individualProjectData: any) => {
  let pcsArray: any = [];
  let customerObj: any;
  // let isConsistShipDate: boolean = false;
  const pcsData: any = individualProjectData.pcs;
  const key: any = "units";
  let sameInstallationTypecount: any;
  let revenue: any;
  let carry: any;
  let totalRevenue: any = 0;
  let totalUnit: any = 0;
  let j: number = 0;

  for (j; j < pcsData.length; j++) {
    if (pcsData[j].ship_date === "") {
      const pcsRevenue = pcsData[j].revenue.replace(/[&\/\\#,+()$?<>{}]/g, '');
      const unitRevenue = pcsRevenue === "" ? 0 : parseFloat(pcsRevenue)
      totalRevenue = totalRevenue + unitRevenue;
      if (j === undefined) {
        pcsArray = [];
      } else if (
        carry !==
        pcsData[j].installation_type +
          " " +
          pcsData[j].enclosure_finish +
          " " +
          pcsData[j].model
      ) {
        sameInstallationTypecount = 1;
        revenue = 0;
        revenue = unitRevenue;
        pcsData[j].revenue = "$" + revenue.toString();
        carry =
          pcsData[j].installation_type +
          " " +
          pcsData[j].enclosure_finish +
          " " +
          pcsData[j].model;
        pcsData[j][key] = sameInstallationTypecount;
        pcsArray.push(pcsData[j]);
        sameInstallationTypecount++;
      } else {
        revenue = revenue + unitRevenue;
        pcsArray[pcsArray.length - 1].units = sameInstallationTypecount;
        pcsArray[pcsArray.length - 1].revenue = "$" + revenue.toFixed(2) ;
        sameInstallationTypecount++;
      }

      // if (isConsistShipDate !== true) {
      //   isConsistShipDate = false;
      // }
      totalUnit++;
      enclosureArray.push(pcsData[j].installation_type);
    }

    // else {
    //   isConsistShipDate = true;
    // }

  }

  /* tslint:disable */
  const posData: any = individualProjectData.pos;
  const newObj = {};
  if (posData !== "" && posData !== null && Object.keys(posData[0]).length > 0) {
    let i: any = 0;
    // @ts-ignore
    newObj["pos_length"] = posData.length;
    for (i = 0; i < posData.length; i++) {
      Object.keys(posData[i]).forEach(key1 => {
        const value = posData[i][key1];
        newObj["pos_" + i + "_" + key1] = value;
      });
    }
  }
/* tslint:enable */

  const pcsTotalRevenue = totalRevenue;
  const customerData = Object.assign(
    {},
    individualProjectData.customer,
    newObj
  );

  /*tslint:disable */
  customerObj = {
    customerData: customerData,
    pcsArray: pcsArray,
    pcsTotalRevenue: pcsTotalRevenue,
    totalUnit: totalUnit
  };
  return customerObj;
};

export const DropdownFilter = (data: any, filterType: any) => {
  const filter: any = filterType.split(',')
  let recordsSorted: any = [];
  if (filterType === 'All') {
    recordsSorted = data;
  } else if (filter[1] === 'sales') {
    recordsSorted = data.filter((val: any) => {
      return val.salesperson === filter[0];
    });
  } else if (filter[1] === 'prod') {
    recordsSorted = data.filter((val: any) => {
      return val.completed_by === filter[0];
    });
  } else {
    recordsSorted = data.filter((val: any) => {
      return val.csm_name === filter[0];
    });
  }
  return recordsSorted;
}

export const getPrevTwoMonthOfCurrntShipMonth = (shipFullYear: number, shipMonth: number) => {
  if (shipMonth === 0) {
    return (shipFullYear - 1) + "-" + 11
  } else if (shipMonth === 1) {
    return (shipFullYear - 1) + "-" + 12
  } else {
    return shipFullYear + "-" + shipMonth
  }
}

export const getShippingLaterBool = (shipFullYear: number, shipMonth: number) => {
  if (shipFullYear > new Date().getFullYear()) {
    return true;
  } else if (shipFullYear === new Date().getFullYear()) {
    if (shipMonth > new Date().getMonth()) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/store/productionReports/productionReportsFilters.ts